import { ROLES, hasAnyRole, isDeveloper, isGeneralAdmin } from "@/utils/roles";
import {
  actualizarSiteSetting,
  obtenerSiteSettingsMap,
} from "@/services/siteSettings/siteSettingsService";

const KEY = "admin.access";

export const adminRoleOptions = [
  { value: ROLES.BOCHAS_ADMIN, label: "Provincial", icon: "shield" },
  { value: ROLES.Asociación_ADMIN, label: "Asociación", icon: "location" },
  { value: ROLES.CLUB_ADMIN, label: "Club", icon: "users" },
];

export const adminGroupDefinitions = [
  { key: "competencias", label: "Competencias", icon: "trophy" },
  { key: "contenido", label: "Contenido", icon: "edit" },
  { key: "instituciones", label: "Instituciones", icon: "landmark" },
  { key: "administracion", label: "Administración", icon: "settings" },
];

export const adminModules = [
  {
    key: "calendario",
    group: "competencias",
    title: "Calendario / Próximas fechas",
    shortTitle: "Calendario",
    description: "Próximos torneos y fechas.",
    to: "/admin/calendario",
    icon: "calendarClock",
    iconClass: "admin-action-card__icon--blue",
    roles: [ROLES.BOCHAS_ADMIN, ROLES.Asociación_ADMIN, ROLES.CLUB_ADMIN],
  },
  {
    key: "resultados",
    group: "competencias",
    title: "Resultados / Podios",
    shortTitle: "Resultados",
    description: "Clasificaciones, podios y fotos.",
    to: "/admin/resultados",
    icon: "trophy",
    iconClass: "admin-action-card__icon--gold",
    roles: [ROLES.BOCHAS_ADMIN, ROLES.Asociación_ADMIN],
  },
  {
    key: "categorias",
    group: "competencias",
    title: "Categorías de torneos",
    shortTitle: "Categorías",
    description: "Catálogo de categorías disponibles.",
    to: "/admin/categorias",
    icon: "categories",
    iconClass: "admin-action-card__icon--blue",
    roles: [ROLES.BOCHAS_ADMIN],
  },
  {
    key: "noticias",
    group: "contenido",
    title: "Noticias",
    description: "Novedades, comunicados y galerías.",
    to: "/admin/noticias",
    icon: "newspaper",
    iconClass: "admin-action-card__icon--red",
    roles: [ROLES.BOCHAS_ADMIN, ROLES.Asociación_ADMIN, ROLES.CLUB_ADMIN],
  },
  {
    key: "historias",
    group: "contenido",
    title: "Historias",
    description: "Historias y notas destacadas.",
    to: "/admin/historias",
    icon: "doc",
    iconClass: "admin-action-card__icon--red",
    roles: [ROLES.BOCHAS_ADMIN, ROLES.Asociación_ADMIN],
  },
  {
    key: "notas",
    group: "contenido",
    title: "Notas",
    description: "Apuntes editoriales.",
    to: "/admin/notas",
    icon: "edit",
    iconClass: "admin-action-card__icon--gold",
    roles: [ROLES.BOCHAS_ADMIN, ROLES.Asociación_ADMIN],
    hidden: true,
  },
  {
    key: "pasado-futuro",
    group: "contenido",
    title: "Pasado y Futuro",
    shortTitle: "Pasado/Futuro",
    description: "Jugadores Históricos y Jóvenes Bochófilos.",
    to: "/admin/pasado-futuro",
    icon: "hourglass",
    iconClass: "admin-action-card__icon--blue",
    roles: [ROLES.BOCHAS_ADMIN, ROLES.Asociación_ADMIN],
  },
  {
    key: "alojamiento",
    group: "contenido",
    title: "Alojamiento",
    description: "Textos, imágenes, comodidades y tarifas.",
    to: "/admin/alojamiento",
    icon: "alojamiento",
    iconClass: "admin-action-card__icon--blue",
    roles: [ROLES.BOCHAS_ADMIN],
    requiresGeneralAdmin: true,
    configurable: false,
  },
  {
    key: "portadas",
    group: "contenido",
    title: "Portadas",
    description: "Imágenes principales del sitio.",
    to: "/admin/portadas",
    icon: "camara",
    iconClass: "admin-action-card__icon--gold",
    roles: [ROLES.BOCHAS_ADMIN],
    requiresGeneralAdmin: true,
    configurable: false,
  },
  {
    key: "asociaciones",
    group: "instituciones",
    title: "Asociaciones",
    description: "Asociaciones regionales y sus clubes.",
    to: "/admin/asociaciones",
    icon: "location",
    iconClass: "admin-action-card__icon--blue",
    roles: [ROLES.BOCHAS_ADMIN],
  },
  {
    key: "federacion",
    group: "instituciones",
    title: "La Federación",
    description: "Autoridades y reglamentaciones.",
    to: "/admin/federacion",
    icon: "shield",
    iconClass: "admin-action-card__icon--red",
    roles: [ROLES.BOCHAS_ADMIN],
    requiresGeneralAdmin: true,
    configurable: false,
  },
  {
    key: "clubes",
    group: "instituciones",
    title: "Clubes",
    description: "Clubes asociados de la provincia.",
    to: "/admin/clubes",
    icon: "users",
    iconClass: "admin-action-card__icon--gold",
    roles: [ROLES.BOCHAS_ADMIN, ROLES.Asociación_ADMIN],
  },
  {
    key: "provincia",
    group: "instituciones",
    title: "Provincias",
    description: "Provincias disponibles para las instituciones.",
    to: "/admin/provincia",
    icon: "map",
    iconClass: "admin-action-card__icon--red",
    roles: [ROLES.BOCHAS_ADMIN],
    requiresGeneralAdmin: true,
  },
  {
    key: "mi-club",
    group: "instituciones",
    title: "Mi Club",
    description: "Información, logo y galería.",
    to: "/admin/mi-club",
    icon: "casa",
    iconClass: "admin-action-card__icon--red",
    roles: [ROLES.CLUB_ADMIN],
  },
  {
    key: "configuracion",
    group: "administracion",
    title: "Configuración",
    description: "Visibilidad, accesos, redes y SEO.",
    to: "/admin/configuracion",
    icon: "settings",
    iconClass: "admin-action-card__icon--blue",
    roles: [ROLES.BOCHAS_ADMIN],
    requiresGeneralAdmin: true,
    configurable: false,
  },
  {
    key: "usuarios",
    group: "administracion",
    title: "Usuarios",
    description: "Accesos internos y contraseñas.",
    to: "/admin/usuarios",
    icon: "users",
    iconClass: "admin-action-card__icon--red",
    roles: [ROLES.BOCHAS_ADMIN, ROLES.Asociación_ADMIN],
    requiresGeneralAdmin: true,
    configurable: false,
  },
  {
    key: "importar",
    group: "administracion",
    title: "Importar datos",
    description: "Carga de archivos CSV o JSON.",
    to: "/admin/importar",
    icon: "upload",
    iconClass: "admin-action-card__icon--blue",
    roles: [ROLES.BOCHAS_ADMIN],
    requiresGeneralAdmin: true,
    configurable: false,
  },
];

export const configurableAdminGroups = adminGroupDefinitions
  .map((group) => ({
    ...group,
    items: adminModules.filter(
      (module) =>
        module.group === group.key &&
        module.configurable !== false &&
        !module.hidden
    ),
  }))
  .filter((group) => group.items.length);

export function adminAccessKey(moduleKey, role) {
  return `${moduleKey}.${role}`;
}

export function crearAdminAccess() {
  return adminModules.reduce((access, module) => {
    if (module.configurable === false || module.hidden) return access;
    module.roles.forEach((role) => {
      access[adminAccessKey(module.key, role)] = true;
    });
    return access;
  }, {});
}

let cachedAccess = null;

export async function obtenerAdminAccess({ force = false } = {}) {
  if (cachedAccess && !force) return { ...cachedAccess };
  const settings = await obtenerSiteSettingsMap();
  const access = crearAdminAccess();

  if (settings[KEY]) {
    try {
      const saved = JSON.parse(settings[KEY]);
      if (saved && typeof saved === "object" && !Array.isArray(saved)) {
        Object.keys(access).forEach((key) => {
          if (typeof saved[key] === "boolean") access[key] = saved[key];
        });
      }
    } catch (_) {
      // Mantener la configuración predeterminada si el valor guardado es inválido.
    }
  }

  cachedAccess = access;
  return { ...access };
}

export async function guardarAdminAccess(access) {
  const normalized = crearAdminAccess();
  Object.keys(normalized).forEach((key) => {
    if (typeof access[key] === "boolean") normalized[key] = access[key];
  });
  await actualizarSiteSetting(KEY, {
    label: "Accesos del administrador",
    group: "access",
    value: JSON.stringify(normalized),
  });
  cachedAccess = normalized;
  return { ...normalized };
}

export function puedeVerModulo(access, module, user) {
  if (!module || module.hidden || !user) return false;
  if (isDeveloper(user)) return true;
  if (!hasAnyRole(user, ...module.roles)) return false;
  if (module.requiresGeneralAdmin && !isGeneralAdmin(user)) return false;
  if (module.configurable === false) return true;
  return access[adminAccessKey(module.key, user.role)] !== false;
}

export function obtenerModuloAdminPorRuta(path) {
  return [...adminModules]
    .sort((a, b) => b.to.length - a.to.length)
    .find((module) => path === module.to || path.startsWith(`${module.to}/`));
}

export async function obtenerProvinciasAdmin() {
  const settings = await obtenerSiteSettingsMap();
  const provincias = JSON.parse(settings["instituciones.provincias"] || "[]");
  if (!Array.isArray(provincias) || provincias.some((item) =>
    !item || typeof item.id !== "string" || typeof item.name !== "string"
  )) {
    throw new Error("El catálogo de provincias tiene un formato inválido.");
  }
  return provincias;
}

export async function guardarProvinciasAdmin(provincias) {
  await actualizarSiteSetting("instituciones.provincias", {
    label: "Provincias",
    group: "instituciones",
    value: JSON.stringify(provincias),
  });
}
